var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuzzer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M10.5 18.658v1.818l.007.816C10.636 23.626 14.836 25.5 20 25.5c5.247 0 9.5-1.934 9.5-4.319v-2.399"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M26.606 15.096c1.785.854 2.894 2.05 2.894 3.375 0 2.594-4.253 4.696-9.5 4.696s-9.5-2.102-9.5-4.696c0-1.297 1.063-2.47 2.782-3.32"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M26.623 13.636v3.758c0 1.809-2.966 3.275-6.623 3.275s-6.623-1.466-6.623-3.276v-3.758"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M20 16.879c3.658 0 6.623-1.466 6.623-3.274S23.658 10.33 20 10.33s-6.623 1.466-6.623 3.274 2.965 3.274 6.623 3.274Z"
}))));
export default SvgBuzzer;